import { render, staticRenderFns } from "./documentView.vue?vue&type=template&id=7c8bfa54&"
import script from "./documentView.vue?vue&type=script&lang=js&"
export * from "./documentView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports